import { SelectDepartmentService } from './department-core';
export const extraSearchKeyMap = {
  project: ['remark'],
};
import { getAllProjectTask } from 'api/application/project-task';

import { getCascadeValueList, getCustomValueList } from 'api/application';
const methodsMap = {
  project: getAllProjectTask,
  custom_list: getCascadeValueList,
  custom_list2: getCustomValueList,
};
export const TREEMap = ({ labelKey }) => {
  return {
    project: {
      [`${labelKey}`]: window.$t('commonForm-1.key628', { cm: '全项目任务' }),
      childrenList: [],
    },
    department: {
      [labelKey]: window.$t('commonForm-1.key116', { cm: '全公司' }),
      childrenList: [],
    },
    default: {
      [labelKey]: window.$t('commonForm-1.key116', { cm: '全公司' }),
      childrenList: [],
    },
  };
};
export class treeCore {
  constructor({ labelKey, codeKey, treeTypeKey }) {
    this.TREE = TREEMap({ labelKey });
    this.rootDeep = undefined;
    this.oidToDeepMap = {}; // 根据oid快速寻找tree的哪一层，原本用pathDepth寻找，但是某次修改之后，没有父部门的节点会挂在根结点下
    this.data = [];
    this.labelKey = labelKey;
    this.codeKey = codeKey;
    this.extraSearchKey = extraSearchKeyMap[treeTypeKey] || [];
  }
  getListData(key, params = {}) {
    return methodsMap[`${key || 'project'}`](params);
  }
  listToTree(list, isSearch = false) {
    const map = {};
    let node;
    let tree = [];
    let i;
    for (i = 0; i < list.length; i++) {
      map[list[i].id] = list[i];
      map[list[i].id].pathName = list[i][this.labelKey];
    }
    for (i = 0; i < list.length; i += 1) {
      node = list[i];
      if (node.parentId) {
        //父节点不存在，本节点作为根节点
        if (!Object.keys(map).includes(node.parentId)) {
          tree.push(node);
        } else {
          // node.path=`${map[node.parentId].path || ''} | ${node.path || ''}`;
          !map[node.parentId].childrenList && (map[node.parentId].childrenList = []);
          map[node.parentId].childrenList.push(node);
        }
      } else {
        tree.push(node);
      }
    }
    this.getTreePath(tree);
    if (!isSearch) {
      this.oidToDeepMap = map;
    }
    let searchList = [];
    if (isSearch) {
      list.forEach((item) => {
        if (!tree.find((curItem) => curItem.id === item.id)) {
          searchList.push(map[item.id]);
        }
      });
    }
    return tree.concat(searchList);
  }
  getTreePath(data, parentName = '') {
    data.forEach((item) => {
      let itemName = item[this.labelKey];
      if (parentName) {
        itemName = parentName + ' | ' + item[this.labelKey];
      }
      item.pathName = itemName;
      if (item.childrenList && item.childrenList.length > 0) {
        this.getTreePath(item.childrenList || [], itemName);
      }
    });
  }
  /*
   这边没必要带入层级概念，陷入复杂逻辑，后续有必要再加
   */
  initTree(data) {
    const { TREE } = this;
    let node = this.listToTree(data);
    TREE.childrenList = node;
    this.data = data;
  }
  getTargetNode(target) {
    const { TREE } = this;
    return TREE;
  }

  getBreadCrumbPath(task, arr = []) {
    const { oidToDeepMap } = this;
    if (!task.parentId) {
      return arr;
    } else {
      let item = oidToDeepMap[`${task.parentId}`];
      if (item) {
        arr.unshift(item);
      }
      return this.getBreadCrumbPath(item, arr);
    }
  }
  search(keyWord) {
    const { oidToDeepMap, extraSearchKey } = this;
    let arr = Object.values(oidToDeepMap);
    let searchKeys = extraSearchKey.concat([this.labelKey, this.codeKey]).filter((item) => item);
    return arr.filter((item) => !!searchKeys.some((key) => item[key].split(keyWord || null).length > 1));
  }
  destroy() {
    this.TREE = TREEMap({ labelKey: this.labelKey });
    this.rootDeep = undefined;
    this.oidToDeepMap = {};
    this.data = [];
  }
  findParentRoot(root) {
    if (!this.oidToDeepMap[root.parentId]) {
      return root;
    }
    return this.findParentRoot(this.oidToDeepMap[root.parentId]);
  }
}

/**
 * coreMap
 * 部门core后续逐渐往treeCore转移
 * 不要开第三个core，在treeCore上兼容
 * @type {{default: treeCore, department: SelectDepartmentService}}
 */
export const coreMap = {
  department: SelectDepartmentService,
  default: treeCore,
};
